export interface CandlePenIngredient {
  name: string
  cas: string
  fraction: number
}

export interface CandlePenColorComposition {
  id: string
  label: string
  ingredients: CandlePenIngredient[]
}

export const candlePensProductInfo = {
  name: 'Colozoo Candle Pens',
  sku: 'cz20 candle pens 16x30ml - fba',
  ean: '4262363890407',
  volumeMlPerPen: 30,
  pensInSet: 16,
} as const

export const candlePensColorCompositions: CandlePenColorComposition[] = [
  {
    id: 'black-28',
    label: 'BLACK-28',
    ingredients: [
      { name: 'Water', cas: '7732-18-5', fraction: 0.603 },
      { name: '2-phenoxyethanol', cas: '122-99-6', fraction: 0.005 },
      { name: 'Petroleum resins,hydrogenated', cas: '71700-94-2', fraction: 0.247 },
      { name: 'Sorbitan monostearate, ethoxylated', cas: '9005-67-8', fraction: 0.029 },
      { name: 'Sorbitan palmitate', cas: '26266-57-9', fraction: 0.029 },
      { name: 'Polyoxyethylene lauryl ether', cas: '9002-92-0', fraction: 0.059 },
      { name: 'Bentonite', cas: '1302-78-9', fraction: 0.025 },
      { name: 'Carbon Black (P.BK.7)', cas: '1333-86-4', fraction: 0.003 },
    ],
  },
  {
    id: 'white-27',
    label: 'WHITE-27',
    ingredients: [
      { name: 'Water', cas: '7732-18-5', fraction: 0.603979 },
      { name: '2-phenoxyethanol', cas: '122-99-6', fraction: 0.005 },
      { name: 'Petroleum resins,hydrogenated', cas: '71700-94-2', fraction: 0.247 },
      { name: 'Sorbitan monostearate, ethoxylated', cas: '9005-67-8', fraction: 0.029 },
      { name: 'Sorbitan palmitate', cas: '26266-57-9', fraction: 0.029 },
      { name: 'Polyoxyethylene lauryl ether', cas: '9002-92-0', fraction: 0.059 },
      { name: 'Bentonite', cas: '1302-78-9', fraction: 0.025 },
      { name: 'Titanium dioxide', cas: '13463-67-7', fraction: 0.002 },
      { name: 'Pyrrolo[3,4-c]pyrrole-1,4-dione, 3,6-bis(4-chlorophenyl)-2,5-dihydro- (P.R.254)', cas: '84632-65-5', fraction: 7e-06 },
      { name: '2-[(4-Chloro-2-nitrophenyl)azo]-N-(2-chlorophenyl)-3-oxobutyramide(P.Y.3)', cas: '6486-23-3', fraction: 1.4e-05 },
    ],
  },
  {
    id: 'pink',
    label: 'PINK',
    ingredients: [
      { name: 'Water', cas: '7732-18-5', fraction: 0.6025 },
      { name: '2-phenoxyethanol', cas: '122-99-6', fraction: 0.005 },
      { name: 'Petroleum resins,hydrogenated', cas: '71700-94-2', fraction: 0.247 },
      { name: 'Sorbitan monostearate, ethoxylated', cas: '9005-67-8', fraction: 0.029 },
      { name: 'Sorbitan palmitate', cas: '26266-57-9', fraction: 0.029 },
      { name: 'Polyoxyethylene lauryl ether', cas: '9002-92-0', fraction: 0.059 },
      { name: 'Bentonite', cas: '1302-78-9', fraction: 0.025 },
      { name: 'Formaldehyde-benzoguanamine resin', cas: '26160-89-4', fraction: 0.0029 },
      { name: 'C.I.Basic Yellow 40', cas: '12221-86-2', fraction: 6e-05 },
      { name: 'C.I.Basic Violet 11', cas: '2390-63-8', fraction: 4e-05 },
      { name: 'Pyrrolo[3,4-c]pyrrole-1,4-dione, 3,6-bis(4-chlorophenyl)-2,5-dihydro- (P.R.254)', cas: '84632-65-5', fraction: 0.0005 },
    ],
  },
  {
    id: 'red-17',
    label: 'RED-17',
    ingredients: [
      { name: 'Water', cas: '7732-18-5', fraction: 0.603 },
      { name: '2-phenoxyethanol', cas: '122-99-6', fraction: 0.005 },
      { name: 'Petroleum resins,hydrogenated', cas: '71700-94-2', fraction: 0.247 },
      { name: 'Sorbitan monostearate, ethoxylated', cas: '9005-67-8', fraction: 0.029 },
      { name: 'Sorbitan palmitate', cas: '26266-57-9', fraction: 0.029 },
      { name: 'Polyoxyethylene lauryl ether', cas: '9002-92-0', fraction: 0.059 },
      { name: 'Bentonite', cas: '1302-78-9', fraction: 0.025 },
      { name: 'Pyrrolo[3,4-c]pyrrole-1,4-dione, 3,6-bis(4-chlorophenyl)-2,5-dihydro- (P.R.254)', cas: '84632-65-5', fraction: 0.0029 },
      { name: 'Carbon Black (P.BK.7)', cas: '1333-86-4', fraction: 0.0001 },
    ],
  },
  {
    id: 'orange-23',
    label: 'ORANGE-23',
    ingredients: [
      { name: 'Water', cas: '7732-18-5', fraction: 0.60265 },
      { name: '2-phenoxyethanol', cas: '122-99-6', fraction: 0.005 },
      { name: 'Petroleum resins,hydrogenated', cas: '71700-94-2', fraction: 0.247 },
      { name: 'Sorbitan monostearate, ethoxylated', cas: '9005-67-8', fraction: 0.029 },
      { name: 'Sorbitan palmitate', cas: '26266-57-9', fraction: 0.029 },
      { name: 'Polyoxyethylene lauryl ether', cas: '9002-92-0', fraction: 0.059 },
      { name: 'Bentonite', cas: '1302-78-9', fraction: 0.025 },
      { name: 'Pyrrolo[3,4-c]pyrrole-1,4-dione, 3,6-bis(4-chlorophenyl)-2,5-dihydro- (P.R.254)', cas: '84632-65-5', fraction: 0.0009 },
      { name: '2-[(4-Chloro-2-nitrophenyl)azo]-N-(2-chlorophenyl)-3-oxobutyramide(P.Y.3)', cas: '6486-23-3', fraction: 0.00245 },
    ],
  },
  {
    id: 'yellow-3',
    label: 'YELLOW-3',
    ingredients: [
      { name: 'Water', cas: '7732-18-5', fraction: 0.603 },
      { name: '2-phenoxyethanol', cas: '122-99-6', fraction: 0.005 },
      { name: 'Petroleum resins,hydrogenated', cas: '71700-94-2', fraction: 0.247 },
      { name: 'Sorbitan monostearate, ethoxylated', cas: '9005-67-8', fraction: 0.029 },
      { name: 'Sorbitan palmitate', cas: '26266-57-9', fraction: 0.029 },
      { name: 'Polyoxyethylene lauryl ether', cas: '9002-92-0', fraction: 0.059 },
      { name: 'Bentonite', cas: '1302-78-9', fraction: 0.025 },
      { name: '2-[(4-Chloro-2-nitrophenyl)azo]-N-(2-chlorophenyl)-3-oxobutyramide(P.Y.3)', cas: '6486-23-3', fraction: 0.003 },
    ],
  },
  {
    id: 'green-19',
    label: 'GREEN-19',
    ingredients: [
      { name: 'Water', cas: '7732-18-5', fraction: 0.603 },
      { name: '2-phenoxyethanol', cas: '122-99-6', fraction: 0.005 },
      { name: 'Petroleum resins,hydrogenated', cas: '71700-94-2', fraction: 0.247 },
      { name: 'Sorbitan monostearate, ethoxylated', cas: '9005-67-8', fraction: 0.029 },
      { name: 'Sorbitan palmitate', cas: '26266-57-9', fraction: 0.029 },
      { name: 'Polyoxyethylene lauryl ether', cas: '9002-92-0', fraction: 0.059 },
      { name: 'Bentonite', cas: '1302-78-9', fraction: 0.025 },
      { name: 'Polychloro copper  phthalocyanine(P.G.7)', cas: '1328-53-6', fraction: 0.003 },
    ],
  },
  {
    id: 'light-blue-6',
    label: 'LIGHT BLUE-6',
    ingredients: [
      { name: 'Water', cas: '7732-18-5', fraction: 0.603 },
      { name: '2-phenoxyethanol', cas: '122-99-6', fraction: 0.005 },
      { name: 'Petroleum resins,hydrogenated', cas: '71700-94-2', fraction: 0.247 },
      { name: 'Sorbitan monostearate, ethoxylated', cas: '9005-67-8', fraction: 0.029 },
      { name: 'Sorbitan palmitate', cas: '26266-57-9', fraction: 0.029 },
      { name: 'Polyoxyethylene lauryl ether', cas: '9002-92-0', fraction: 0.059 },
      { name: 'Bentonite', cas: '1302-78-9', fraction: 0.025 },
      { name: '29H,31H-phthalocyaninato(2-)-N29,N30,N31,N32 copper (P.B.15:3)', cas: '147-14-8', fraction: 0.002 },
      { name: 'Titanium dioxide', cas: '13463-67-7', fraction: 0.001 },
    ],
  },
  {
    id: 'dark-blue-29',
    label: 'DARK BLUE-29',
    ingredients: [
      { name: 'Water', cas: '7732-18-5', fraction: 0.6024 },
      { name: '2-phenoxyethanol', cas: '122-99-6', fraction: 0.005 },
      { name: 'Petroleum resins,hydrogenated', cas: '71700-94-2', fraction: 0.247 },
      { name: 'Sorbitan monostearate, ethoxylated', cas: '9005-67-8', fraction: 0.029 },
      { name: 'Sorbitan palmitate', cas: '26266-57-9', fraction: 0.029 },
      { name: 'Polyoxyethylene lauryl ether', cas: '9002-92-0', fraction: 0.059 },
      { name: 'Bentonite', cas: '1302-78-9', fraction: 0.025 },
      { name: '29H,31H-phthalocyaninato(2-)-N29,N30,N31,N32 copper (P.B.15:3)', cas: '147-14-8', fraction: 0.0035 },
      { name: 'Pyrrolo[3,4-c]pyrrole-1,4-dione, 3,6-bis(4-chlorophenyl)-2,5-dihydro- (P.R.254)', cas: '84632-65-5', fraction: 0.0001 },
    ],
  },
  {
    id: 'purple-26',
    label: 'PURPLE-26',
    ingredients: [
      { name: 'Water', cas: '7732-18-5', fraction: 0.6015 },
      { name: '2-phenoxyethanol', cas: '122-99-6', fraction: 0.005 },
      { name: 'Petroleum resins,hydrogenated', cas: '71700-94-2', fraction: 0.247 },
      { name: 'Sorbitan monostearate, ethoxylated', cas: '9005-67-8', fraction: 0.029 },
      { name: 'Sorbitan palmitate', cas: '26266-57-9', fraction: 0.029 },
      { name: 'Polyoxyethylene lauryl ether', cas: '9002-92-0', fraction: 0.059 },
      { name: 'Bentonite', cas: '1302-78-9', fraction: 0.025 },
      { name: '8,18-dichloro-5,15-diethyl-5,15-dihydrodiindolo[3,2-b:3\',2\'-m]triphenodioxazine(P.V.23)', cas: '6358-30-1', fraction: 0.0045 },
    ],
  },
  {
    id: 'neon-pink-20',
    label: 'NEON PINK-20',
    ingredients: [
      { name: 'Water', cas: '7732-18-5', fraction: 0.603 },
      { name: '2-phenoxyethanol', cas: '122-99-6', fraction: 0.005 },
      { name: 'Petroleum resins,hydrogenated', cas: '71700-94-2', fraction: 0.247 },
      { name: 'Sorbitan monostearate, ethoxylated', cas: '9005-67-8', fraction: 0.029 },
      { name: 'Sorbitan palmitate', cas: '26266-57-9', fraction: 0.029 },
      { name: 'Polyoxyethylene lauryl ether', cas: '9002-92-0', fraction: 0.059 },
      { name: 'Bentonite', cas: '1302-78-9', fraction: 0.025 },
      { name: 'Formaldehyde-benzoguanamine resin', cas: '26160-89-4', fraction: 0.0029 },
      { name: 'C.I.Basic Yellow 40', cas: '12221-86-2', fraction: 6e-05 },
      { name: 'C.I.Basic Violet 11', cas: '2390-63-8', fraction: 4e-05 },
    ],
  },
  {
    id: 'neon-yellow-21',
    label: 'NEON YELLOW-21',
    ingredients: [
      { name: 'Water', cas: '7732-18-5', fraction: 0.603 },
      { name: '2-phenoxyethanol', cas: '122-99-6', fraction: 0.005 },
      { name: 'Petroleum resins,hydrogenated', cas: '71700-94-2', fraction: 0.247 },
      { name: 'Sorbitan monostearate, ethoxylated', cas: '9005-67-8', fraction: 0.029 },
      { name: 'Sorbitan palmitate', cas: '26266-57-9', fraction: 0.029 },
      { name: 'Polyoxyethylene lauryl ether', cas: '9002-92-0', fraction: 0.059 },
      { name: 'Bentonite', cas: '1302-78-9', fraction: 0.025 },
      { name: 'Formaldehyde-benzoguanamine resin', cas: '26160-89-4', fraction: 0.0029 },
      { name: 'C.I.Basic Yellow 40', cas: '12221-86-2', fraction: 0.0001 },
    ],
  },
  {
    id: 'neon-green',
    label: 'NEON GREEN',
    ingredients: [
      { name: 'Water', cas: '7732-18-5', fraction: 0.6004 },
      { name: '2-phenoxyethanol', cas: '122-99-6', fraction: 0.005 },
      { name: 'Petroleum resins,hydrogenated', cas: '71700-94-2', fraction: 0.247 },
      { name: 'Sorbitan monostearate, ethoxylated', cas: '9005-67-8', fraction: 0.029 },
      { name: 'Sorbitan palmitate', cas: '26266-57-9', fraction: 0.029 },
      { name: 'Polyoxyethylene lauryl ether', cas: '9002-92-0', fraction: 0.059 },
      { name: 'Bentonite', cas: '1302-78-9', fraction: 0.025 },
      { name: 'Formaldehyde-benzoguanamine resin', cas: '26160-89-4', fraction: 0.0053 },
      { name: 'C.I.Basic Yellow 40', cas: '12221-86-2', fraction: 0.0001 },
      { name: 'Cyanine Green', cas: '147-14-8', fraction: 0.0002 },
    ],
  },
  {
    id: 'gold-1',
    label: 'GOLD-1',
    ingredients: [
      { name: 'Water', cas: '7732-18-5', fraction: 0.603 },
      { name: '2-phenoxyethanol', cas: '122-99-6', fraction: 0.005 },
      { name: 'Petroleum resins,hydrogenated', cas: '71700-94-2', fraction: 0.247 },
      { name: 'Sorbitan monostearate, ethoxylated', cas: '9005-67-8', fraction: 0.029 },
      { name: 'Sorbitan palmitate', cas: '26266-57-9', fraction: 0.029 },
      { name: 'Polyoxyethylene lauryl ether', cas: '9002-92-0', fraction: 0.059 },
      { name: 'Bentonite', cas: '1302-78-9', fraction: 0.025 },
      { name: 'Mica', cas: '12001-26-2', fraction: 0.0016 },
      { name: 'Titanium dioxide', cas: '13463-67-7', fraction: 0.0011 },
      { name: 'Ferric oxide', cas: '1309-37-1', fraction: 0.0003 },
    ],
  },
  {
    id: 'silver-4',
    label: 'SILVER -4',
    ingredients: [
      { name: 'Water', cas: '7732-18-5', fraction: 0.603 },
      { name: '2-phenoxyethanol', cas: '122-99-6', fraction: 0.005 },
      { name: 'Petroleum resins,hydrogenated', cas: '71700-94-2', fraction: 0.247 },
      { name: 'Sorbitan monostearate, ethoxylated', cas: '9005-67-8', fraction: 0.029 },
      { name: 'Sorbitan palmitate', cas: '26266-57-9', fraction: 0.029 },
      { name: 'Polyoxyethylene lauryl ether', cas: '9002-92-0', fraction: 0.059 },
      { name: 'Bentonite', cas: '1302-78-9', fraction: 0.025 },
      { name: 'Mica', cas: '12001-26-2', fraction: 0.0016 },
      { name: 'Titanium dioxide', cas: '13463-67-7', fraction: 0.0013 },
      { name: 'Carbon Black (P.BK.7)', cas: '1333-86-4', fraction: 0.0001 },
    ],
  },
  {
    id: 'glow-in-the-dark-white',
    label: 'Glow in the dark-white',
    ingredients: [
      { name: 'Water', cas: '7732-18-5', fraction: 0.5757 },
      { name: '2-phenoxyethanol', cas: '122-99-6', fraction: 0.00475 },
      { name: 'Petroleum resins,hydrogenated', cas: '71700-94-2', fraction: 0.23465 },
      { name: 'Sorbitan monostearate, ethoxylated', cas: '9005-67-8', fraction: 0.02755 },
      { name: 'Sorbitan palmitate', cas: '26266-57-9', fraction: 0.02755 },
      { name: 'Polyoxyethylene lauryl ether', cas: '9002-92-0', fraction: 0.05605 },
      { name: 'Bentonite', cas: '1302-78-9', fraction: 0.02375 },
      { name: 'Zinc sulfide (ZnS), copper chloride-doped', cas: '68611-70-1', fraction: 0.05 },
    ],
  },
]
